<template>
  <a-modal
    :visible="props.visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :footer="false"
    :wrap-style="{ overflow: 'hidden' }"
    ref="modalErrorRef"
    wrapClassName="delete-slot-modal"
  >
    <div class="error-modal">
      <div class="icon">
        <CloseCircleFilled />
      </div>
      <div class="info">
        <h3>
          Los acuerdos de pagos de tu empresa requieren tener como mínimo
          {{ props.slots?.slot_min }} slots
        </h3>
        <p>
          Actualmente los acuerdos de tu contrato requieren tener mínimo
          {{ props.slots?.slot_min }} slots en tu plataforma.
        </p>
        <div class="btn">
          <a-button type="primary" @click="handleOk()"> Aceptar </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { CloseCircleFilled } from "@ant-design/icons-vue";

const props = defineProps({ open: Boolean, state: String, slots: Object, visible: Boolean });

const emit = defineEmits(["update:visible"]);

const handleOk = () => {
  emit("update:visible", false);
};

const handleCancel = () => {
  emit("update:visible", false);
};
</script>
<style lang="sass" scoped>
.ant-modal-body
  .input
    &-message
      width: 100%
      border: 1px solid $gray-5
      border-radius: 4px
      height: 32px
      padding: 0 9px
  .anticon
    &-delete
      font-size: 64px
      color: $red-6
.error
  &-modal
    display: flex
    .icon
      width: 10%
      span
        font-size: 24px
        color: #FF4D4F
    .info
      width: 80%
      .btn
        display: flex
        justify-content: flex-end
</style>
